import React from "react";
import { Timeline } from "antd";
import { motion } from "framer-motion";
import WorkExperienceItem from "./WorkExperienceItem";
import "./WorkExperience.css";

const workExperiences = [
  {
    title: "AI Banking Intern",
    company: "E.Sun Bank",
    date: "Jun 2024 - Present",
    description: "description description.",
  },
  {
    title: "AI&ML Researcher",
    company: "MIT CSAIL",
    date: "Sep 2023 - Present",
    description: "description description.",
  },
  {
    title: "Full Stack Developer",
    company: "Recovering Bro Tech",
    date: "Jan 2024 - Feb 2024",
    description: "description description.",
  },
];

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2,
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 },
};

function WorkExperience() {
  return (
    <motion.div
      className="work-experience"
      initial="hidden"
      animate="visible"
      variants={containerVariants}
    >
      <Timeline>
        {workExperiences.map((experience, index) => (
          <Timeline.Item key={index}>
            <motion.div variants={itemVariants}>
              <WorkExperienceItem {...experience} />
            </motion.div>
          </Timeline.Item>
        ))}
      </Timeline>
    </motion.div>
  );
}

export default WorkExperience;
